import { ItemSource } from './source-section.model';
import { WishListPagination } from '../../inputs';
import { PageInfo, Pager } from '../common/pagination.model';
import { CatalogueInfoResponse, ProductVariant } from './product.model';

export interface WishlistResponse extends Pager {
  wishlists: WishlistInfo[];
}

export interface OneWishlistResponse {
  wishlist: WishlistInfo;
}

export interface WishlistInfo {
  id: string;
  date: Date;
  wishlistCategory: WishlistCategory;
  product: CatalogueInfoResponse;
}

// Wishlist Category
export interface WishlistCategoriesResponse extends Pager {
  wishlistCategories: WishlistCategory[];
}

export interface WishlistByCategoryResponse extends Pager {
  wishlists: WishlistInfo[];
}

export interface WishlistCategory {
  id: string;
  name: string;
  is_default: boolean;
  createdAt?: string;
  updatedAt?: string;
  pagination?: WishListPagination;
}

export interface GetWishlistCategoriesResponse {
  status: string;
  data: WishlistCategory[];
}

export interface CreateWishlistInput {
  name: string;
  is_default: boolean;
}

export interface WishlistProductByCategory extends Pager {
  records: wishlistItems[];
}

export interface wishlistItems extends ItemSource {
  user_wishlist_id: string;
  product_variant_id: string;
  product_variant:ProductVariant
}

export interface GetwishProductIds{
  data: string[];
}
export interface adminWish{
  user_id: string;
  full_name: string;
  items_in_wishlist: number | string;
  date_created: string;
}
export interface adminWishlistResponse {
    pagination: PageInfo;
  records: adminWish[];
}

export interface adminWishListItems{
    pagination: PageInfo;
    records:ProductVariant[];
}

export interface WishlistProductRes {
  id: string;
  name: string;
  is_default: boolean;
}
